import React, { useEffect, useState, useRef } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { isValidPinCode } from "../../../lib/regexHelpers";
import { getAreaByPin } from "../../../Api/PropertyMst/Api";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../../lib/axios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomAutocomplete from "../../AutoComplete/AutoComplete";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "AccLedName", label: "Ledger Name", minWidth: 10 },
  { id: "AccLedAbvr", label: "Abbreviation", minWidth: 50 },
  { id: "AccLedAdd", label: "Address", minWidth: 50 },
  { id: "Tel", label: "Telephone", minWidth: 50 },
  { id: "CityName", label: "City", minWidth: 50 },
  { id: "EmailId", label: "Email", minWidth: 50 },
  { id: "Pan", label: "Pan", minWidth: 50 },
  { id: "Tan", label: "Tan", minWidth: 50 },
  { id: "Intrt", label: "Intrt", minWidth: 50 },
];

const Ledgers = () => {
  const [formData, setFormData] = useState({
    AccLedName: "",
    AccLedAbvr: "",
    AccLgrpId: "",
    AccLedAdd: "",
    SgrnDt: new Date().toISOString().split("T")[0],
    Pan: "",
    Tan: "",
    Reg: "",
    CityName: "",
    StateName: "",
    PinCode: "",
    PinId: "",
    ContKey: "India",
    Tel: "",
    EmailId: "",
    OpBalance: "0.00",
    Cst: "",
    Intrt: "0.00",
    Remark: "",
    AreaName: "",
  });

  const [error, setError] = useState({
    AccLedName: false,
    AccLedAbvr: false,
    AccLedAdd: false,
    Pan: false,
    Tan: false,
    PinId: false,
    CityName: false,
    StateName: false,
    ContKey: false,
    Tel: false,
    EmailId: false,
    SgrnDt: false,
    OpBalance: false,
    Cst: false,
    Intrt: false,
    AccLgrpId: false,
    AreaName: false,
  });

  const navigate = useNavigate();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const location = useLocation();
  const [currentAuthId, setCurrentAuthId] = useState(null);
  const [Subgroupdrp, setSubgroupdrp] = useState([]);
  const [mode, setMode] = useState("view");
  const [lastInsertedAuthId, setLastInsertedAuthId] = useState(null);
  const [Status, setStatus] = useState("1");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const [lastValidData, setLastValidData] = useState(null);
  const [area, setArea] = useState([]);
  const [sites, setSites] = useState([]);

  const NameRef = useRef(null);
  const MobileNoRef = useRef(null);
  const DesignationRef = useRef(null);

  const requiredFields = ["AccLedName", "PinCode", "AccLgrpId", "AreaName"];

  // Helper function to reset form and error states
  const resetFormAndErrors = () => {
    setFormData({
      AccLedName: "",
      AccLedAbvr: "",
      AccLgrpId: "",
      AccLedAdd: "",
      SgrnDt: new Date().toISOString().split("T")[0],
      Pan: "",
      Tan: "",
      CityName: "",
      StateName: "",
      ContKey: "India",
      Tel: "",
      EmailId: "",
      OpBalance: "0.00",
      Reg: "",
      Cst: "",
      Intrt: "0.00",
      Remark: "",
      PinId: "",
      PinCode: "",
      AreaName: "",
    });
    setError({
      AccLedName: false,
      AccLedAbvr: false,
      AccLedAdd: false,
      Pan: false,
      Tan: false,
      PinId: false,
      CityName: false,
      StateName: false,
      ContKey: false,
      Tel: false,
      EmailId: false,
      SgrnDt: false,
      OpBalance: false,
      Cst: false,
      Intrt: false,
      AccLgrpId: false,
      AreaName: false,
    });
  };

  useEffect(() => {
    const fetchSubgroupData = async () => {
      try {
        const response = await axiosInstance.post(`AccLgrp/GetAccLgrpDrp`, {});
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          const transformedData = response.data.Data.map((item) => ({
            Id: item.AccLgrpId,
            Name: item.AccLgrpName,
          }));
          setSubgroupdrp(transformedData);
        } else {
          toast.error("Failed to fetch Subgroup");
        }
      } catch (error) {
        toast.error("Error fetching Subgroup. Please try again.");
      }
    };

    fetchSubgroupData();
  }, []);

  // Pincode Api
  useEffect(() => {
    if (isValidPinCode(formData.PinCode)) {
      (async () => {
        const result = await getAreaByPin(formData.PinCode);
        if (result && Array.isArray(result)) {
          setArea(result);
        } else {
          setArea([]);
        }
      })();
    } else {
      setArea([]);
      setFormData((prevData) => ({
        ...prevData,
        CityName: "",
        StateName: "",
        ContKey: "India",
        PinId: "",
        CityId: "",
        AreaName: "",
      }));
    }
  }, [formData.PinCode]);

  useEffect(() => {
    const fetchPlaces = async (PinCode, areaName) => {
      if (!PinCode || !areaName) return;
      try {
        const response = await axiosInstance.post(
          `PinCodeMst/getdrpPinCodeAreawise_datafill`,
          {
            PinCode: parseInt(PinCode),
            AreaName: areaName,
          }
        );
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setSites(response.data.Data);
          const { CityName, StateName, CountryName, PinId, CityId } =
            response.data.Data[0] || {};
          setFormData((prevData) => ({
            ...prevData,
            CityName: CityName || "",
            StateName: StateName || "",
            ContKey: CountryName || "India",
            PinId: PinId?.toString() || "",
            CityId: CityId?.toString() || "",
          }));
        } else {
          toast.error("Failed to fetch PinCodeArea");
        }
      } catch (error) {
        toast.error("Error fetching PinCodeArea. Please try again.");
      }
    };

    if (isValidPinCode(formData.PinCode) && formData.AreaName) {
      fetchPlaces(formData.PinCode.trim(), formData.AreaName);
    }
  }, [formData.PinCode, formData.AreaName]);

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post("AccLed/GetAccLedDashBoard", {
          SearchText: "",
        });
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          setRows([]);
          setDataForPrint({});
        }
      } catch (err) {
        toast.error("Error fetching dashboard data");
      }
    };
    getRow();
  }, []);

  useEffect(() => {
    if (location.state && location.state.AccLedId) {
      setCurrentAuthId(location.state.AccLedId);
      fetchLedgerData(location.state.AccLedId, "R");
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  const handlePrevious = async () => {
    if (currentAuthId && currentAuthId > 1) {
      await fetchLedgerData(currentAuthId, "P");
    }
  };

  const handleNext = async () => {
    if (currentAuthId) {
      await fetchLedgerData(currentAuthId, "N");
    }
  };

  const handleInputChange = (event, newValue) => {
    if (event && event.target) {
      const { name, value } = event.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setError((prev) => ({
        ...prev,
        [name]: !value && requiredFields.includes(name),
      }));
    } else {
      const selectedId = newValue ? newValue.Id.toString() : "";
      setFormData((prev) => ({
        ...prev,
        AccLgrpId: selectedId,
      }));
      setError((prev) => ({ ...prev, AccLgrpId: !selectedId }));
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === NameRef.current) {
        MobileNoRef.current.focus();
      } else if (event.target === MobileNoRef.current) {
        DesignationRef.current.focus();
      } else {
        handleSubmit();
      }
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  // Code to insert and update the data
  const handleSubmit = async () => {
    let hasError = false;
    const updatedError = { ...error };

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        updatedError[field] = true;
        toast.error(`${field.replace(/([A-Z])/g, " $1").trim()} is required`);
        hasError = true;
      } else {
        updatedError[field] = false;
      }
    });
    setError(updatedError);

    if (hasError) return;

    try {
      const currentDate = new Date().toISOString().split("T")[0];
      const payload = {
        AccLedName: formData.AccLedName,
        AccLedAbvr: formData.AccLedAbvr,
        AccLgrpId: parseInt(formData.AccLgrpId),
        AccLedAdd: formData.AccLedAdd,
        CityName: formData.CityName,
        ContKey: formData.ContKey,
        Tel: formData.Tel,
        Fax: "" || "0",
        EmailId: formData.EmailId,
        SgrnDt: formData.SgrnDt || currentDate,
        Reg: formData.Reg || "0",
        StateName: formData.StateName,
        Cst: "" || "0",
        PinId: parseInt(formData.PinId) || 0,
        ExciseCode: "EXC001",
        Pan: formData.Pan,
        Tan: formData.Tan,
        Intrt: parseFloat(formData.Intrt),
        CcnFlag: "N",
        Sst: "" || "Ash",
        CcnKey: "" || "0",
        Status: Status,
        Remark: formData.Remark || "No remarks provided",
      };

      let response;
      if (mode === "edit") {
        payload.AccLedId = currentAuthId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post("AccLed/UpdateAccLed", payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post("AccLed/InsertAccLed", payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === "add") {
          setLastInsertedAuthId(response.data.Data);
          await fetchLedgerData(response.data.Data, "R");
          setMode("view");
          setIsFormDisabled(true);
          setCurrentAuthId(response.data.Data);
        } else {
          setMode("view");
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || "Failed to save ledger");
      }
    } catch (error) {
      toast.error("Error saving ledger");
    }
  };

  const fetchLedgerData = async (id, flag) => {
    try {
      const response = await axiosInstance.post("AccLed/RetriveAccLed", {
        AccLedId: id,
        Flag: flag,
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const ledgerData = Array.isArray(response.data.Data) ? response.data.Data[0] : response.data.Data;
        if (ledgerData) {
          setFormData({
            AccLedName: ledgerData.AccLedName || "",
            AccLedAbvr: ledgerData.AccLedAbvr || "",
            AccLgrpId: ledgerData.AccLgrpId?.toString() || "",
            AccLedAdd: ledgerData.AccLedAdd || "",
            SgrnDt: ledgerData.SgrnDt || new Date().toISOString().split("T")[0],
            Pan: ledgerData.Pan || "",
            Tan: ledgerData.Tan || "",
            CityName: ledgerData.CityName || "",
            StateName: ledgerData.StateName || "",
            ContKey: ledgerData.ContKey || "India",
            Tel: ledgerData.Tel || "",
            EmailId: ledgerData.EmailId || "",
            OpBalance: ledgerData.OpBalance || "0.00",
            Cst: ledgerData.Cst || "",
            Reg: ledgerData.Reg || "",
            Intrt: ledgerData.Intrt || "0.00",
            Remark: ledgerData.Remark || "",
            PinId: ledgerData.PinId?.toString() || "",
            PinCode: ledgerData.PinCode?.toString() || "",
            AreaName: ledgerData.AreaName || "",
          });
          setStatus(ledgerData.Status?.toString() || "1");
          setCurrentAuthId(ledgerData.AccLedId);
          setIsFormDisabled(true);
          setMode("view");
        }
      } else {
        toast.info(response.data.Message || "No ledger data found");
      }
    } catch (error) {
      toast.error("Error fetching Ledger data");
    }
  };

  const handleEdit = async () => {
    if (!currentAuthId) {
      toast.error("No record selected to edit");
      return;
    }
    let flag = await checkAndLock(currentAuthId, "AccLed", "AccLedId");
    switch (flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        setTimeout(() => NameRef.current.focus(), 0);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Lock", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setLastValidData(formData);
    setMode("add");
    setIsFormDisabled(false);
    resetFormAndErrors();
    setStatus("1");
    setCurrentAuthId(null);
    setArea([]);
    setSites([]);
    setTimeout(() => NameRef.current.focus(), 0);

    // Automatically select the first property if available
    if (Subgroupdrp.length > 0) {
      setFormData((prevState) => ({
        ...prevState,
        AccLgrpId: Subgroupdrp[0].Id.toString(),
      }));
    }
  };

  const handleCancel = async () => {
    try {
      await UnLock(currentAuthId, "AccLed", "AccLedId");
      resetFormAndErrors();
      await fetchLedgerData(1, "L");
      setStatus("1");
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      toast.error("Error occurred while cancelling");
    }
  };

  const resetForm = () => {
    resetFormAndErrors();
    setCurrentAuthId(null);
    setMode("view");
    setStatus("1");
    setIsFormDisabled(true);
    setArea([]);
    setSites([]);
  };

  const handleExit = () => {
    navigate("/ledgertable");
  };

  const handleDeleteClick = () => {
    if (currentAuthId) {
      setOpenConfirmDialog(true);
    } else {
      toast.error("No record selected to delete");
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    let flag = await checkAndLock(currentAuthId, "AccLed", "AccLedId");
    switch (flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchLedgerData(currentAuthId, "D");
        await fetchLedgerData(currentAuthId, "N");
        setStatus("1");
        setIsFormDisabled(true);
        break;
      case 1:
        toast.info("Record is already locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Failed to lock record", { autoClose: 500 });
        break;
      default:
        toast.info("Something went wrong", { autoClose: 500 });
    }
  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid item xs={12} className="form_title" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "20px", flexDirection: { xs: "column", sm: "row", md: "row" } }}>
            <Grid sx={{ display: "flex", justifyContent: { xs: "center", sm: "flex-start" }, marginBottom: { xs: "10px", sm: 0 } }}>
              <Button variant="contained" size="small" className="three-d-button-previous" onClick={handlePrevious} sx={{ backgroundColor: "#635BFF", marginRight: { xs: "5px", sm: "10px" }, display: { xs: "none", sm: "block" } }} disabled={mode !== "view" || !currentAuthId || currentAuthId === 1}>
                <KeyboardArrowLeftIcon />
              </Button>
              <Button variant="contained" size="small" className="three-d-button-next" onClick={handleNext} sx={{ backgroundColor: "#635BFF", display: { xs: "none", sm: "block" } }} disabled={mode !== "view" || !currentAuthId}>
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography variant="h5" sx={{ margin: "auto", textAlign: { xs: "center", sm: "center" }, fontSize: { xs: "24px", sm: "18px", md: "24px" } }}>
              General Ledger
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Ledgers"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDeleteClick}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="AccLedName"
                  name="AccLedName"
                  label={<span>Ledger Name <span style={{ color: "red" }}>*</span></span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.AccLedName}
                  onChange={handleInputChange}
                  error={error.AccLedName}
                  inputRef={NameRef}
                  onKeyDown={handleKeyPress}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  id="AccLedAbvr"
                  name="AccLedAbvr"
                  label={<span>Abvr</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.AccLedAbvr}
                  onChange={handleInputChange}
                  inputRef={MobileNoRef}
                  onKeyDown={handleKeyPress}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  id="Reg"
                  name="Reg"
                  label={<span>Reg/GST No</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Reg}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  id="Tel"
                  name="Tel"
                  label={<span>Phone No</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Tel}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  id="EmailId"
                  name="EmailId"
                  label={<span>Email</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.EmailId}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <CustomAutocomplete
                  options={Subgroupdrp}
                  id="AccLgrpId-autocomplete"
                  name="AccLgrpId"
                  label={<span>Subgroup <span style={{ color: "red" }}>*</span></span>}
                  value={Subgroupdrp.find((subgroup) => subgroup.Id === parseInt(formData.AccLgrpId)) || null}
                  onChange={handleInputChange}
                  getOptionLabel={(option) => option.Name || ""}
                  error={error.AccLgrpId}
                  disabled={isFormDisabled}
                  noOptionsText="No value available"
                  ref={DesignationRef}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  id="Pan"
                  name="Pan"
                  label={<span>PAN</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Pan}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  id="Tan"
                  name="Tan"
                  label={<span>TAN</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Tan}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  id="PinCode"
                  name="PinCode"
                  label={<span>PinCode <span style={{ color: "red" }}>*</span></span>}
                  variant="filled"
                  fullWidth
                  type="text"
                  className="custom-textfield"
                  value={formData.PinCode}
                  onChange={handleInputChange}
                  error={error.PinCode}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2} className="form_field">
                <FormControl variant="filled" fullWidth className="custom-select">
                  <InputLabel id="area-select-label">Area <span style={{ color: "red" }}>*</span></InputLabel>
                  <Select
                    labelId="area-select-label"
                    id="area-select"
                    name="AreaName"
                    value={formData.AreaName}
                    onChange={handleInputChange}
                    className="custom-textfield"
                    error={error.AreaName}
                    disabled={isFormDisabled}
                  >
                    {area.length > 0 ? (
                      area.map((areaItem) => (
                        <MenuItem key={areaItem.Id} value={areaItem.Name}>
                          {areaItem.Name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        No areas available
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  id="CityName"
                  name="CityName"
                  label={<span>City</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.CityName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  id="StateName"
                  name="StateName"
                  label={<span>State</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.StateName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={4} lg={2}>
                <TextField
                  id="ContKey"
                  name="ContKey"
                  label={<span>Country</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.ContKey}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="AccLedAdd"
                  name="AccLedAdd"
                  label={<span>Address</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.AccLedAdd}
                  onChange={handleInputChange}
                  multiline
                  rows={1}
                  sx={{
                    "& .MuiInputBase-root": { height: "60px" },
                    "& .MuiInputBase-input": { resize: "vertical" },
                    "& .MuiFilledInput-root": {
                      "&:hover": { backgroundColor: "transparent" },
                      "&.Mui-focused": { backgroundColor: "transparent" },
                    },
                  }}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label={<span>Remark</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  multiline
                  rows={1}
                  sx={{
                    "& .MuiInputBase-root": { height: "60px" },
                    "& .MuiInputBase-input": { resize: "vertical" },
                    "& .MuiFilledInput-root": {
                      "&:hover": { backgroundColor: "transparent" },
                      "&.Mui-focused": { backgroundColor: "transparent" },
                    },
                  }}
                  disabled={isFormDisabled}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1} justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  id="Intrt"
                  name="Intrt"
                  label={<span>Interest Rate</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Intrt}
                  type="number"
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  id="OpBalance"
                  name="OpBalance"
                  label={<span>Op Balance</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.OpBalance}
                  type="number"
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  id="SgrnDt"
                  name="SgrnDt"
                  label={<span>Op Date</span>}
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  type="date"
                  value={formData.SgrnDt}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                  disabled={isFormDisabled}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <FormGroup sx={{ display: "flex", justifyContent: "center" }}>
                  <FormControlLabel
                    control={<Checkbox disabled={isFormDisabled} checked={Status === "1"} onChange={handleChangeStatus} />}
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button" sx={{ textAlign: "center" }}>
            {mode === "view" && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: "linear-gradient(290deg, #d4d4d4, #ffffff)" }} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: "linear-gradient(290deg, #a7c5e9, #ffffff)" }} disabled>
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Ledger"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>

      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this ledger record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{ backgroundColor: "#635bff", color: "white", "&:hover": { backgroundColor: "#1565c0", color: "white" } }} onClick={handleConfirmDelete}>
            Yes
          </Button>
          <Button sx={{ backgroundColor: "#635bff", color: "white", "&:hover": { backgroundColor: "#1565c0", color: "white" } }} onClick={handleCloseConfirmDialog}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Ledgers;